<template>

  <div class="this">

    <label class="visit">{{ $t('Visit') }} <a href="https://winerz.com" target="_blank">winerz.com</a></label>

    <!-- <h1>{{ $t('Welcome back!') }}</h1>

    <div class="flex social-buttons">
      <button v-if="!socialClicked" @click="socialClicked = true" class="socialbtn google">{{ $t('Sign in with Google') }}</button>
      <button v-if="!socialClicked" @click="socialClicked = true" class="socialbtn facebook">{{ $t('Sign in with Facebook') }}</button>

      <div class="explain" v-if="socialClicked">
        <br />
        <label>{{ $t('To adapt to the web3, social login is not possible anymore.') }}</label>
        <br />
        <br />
        {{ $t('If you previously had and account on Winerz with a social account, we invite you to register again with the same e-mail, your new account will be automatically linked to the previous one.') }}
        <br />
        <br />
        <router-link to="/register">{{ $t('Click here to create or link your Account') }}</router-link>
        <br />
        <small v-html="$t('use-same-email')"></small>
        <br />
        <br />
      </div>

    </div>

    <div class="or"><span>or</span></div> -->

    <form @submit.prevent="logIn">
      
      <p>
        <label for="signin_email">
          <span>{{$t('E-mail address')}}:</span>
          <input type="email" name="email" id="signin_email" :placeholder="$t('E-mail address')" required  v-model="email" />
          <span class="error" for="email"></span>
        </label>
      </p>
      
      <p>
        <label for="signin_password">
          <span>{{$t('Password')}}:</span>
          <input type="password" name="password" id="signin_password" :placeholder="$t('Password')" required  v-model="password" />
          <span class="error" for="password"></span>
        </label>
      </p>

      <p>
        <input type="submit" :value="wait ? $t(`Please wait...`) : $t(`Log In`)" class="button btn_blue" :disabled="wait">
        <span class="block error text-center" v-show="loginErr !== ''">
          <br />
          {{loginErr}}
        </span>
      </p>

    </form>

    <br>
    <router-link to="/forgot-password" class="block text-center">{{$t('Forgot your password?')}}</router-link>
    <br>
    <router-link to="/register" class="block text-center">{{$t('Create an account')}}</router-link>

  </div>
    

</template>


<style scoped>

.this {
  position : relative;
}
.visit {
  color : white;
  text-align : center;
  position: absolute;
  bottom : -7rem;
  left : 0;
  display : block;
  width : 100%;
}
.visit a { color : white !important; text-underline-offset: .1rem; }

.explain {
  text-align: center;
}
.explain label {
  font-weight: bold;
  font-size: 1.1rem;
}
.explain a {
  font-weight: bold;
  text-decoration: underline;
  text-underline-offset: 0.1rem;  
}
.explain span {

}
</style>

<script>

import { authService } from '../services/auth';

export default {
  name: 'Login',
  metaInfo () { 
    return { title: this.$t("meta-title") } 
  },
  data: function()
  {
    return {
      email : "",
      password : "",
      wait: false,
      loginErr : "",
      socialClicked: false
    }
  },
  mounted() {

    window.analytics.page('login-page');
    window.analytics.track('visit-login-page');

  },
  methods:
  {
    ...authService,

    logIn: async function()
    {
      this.wait = true
      this.loginErr = ''
      
      try {
        
        const user = await authService.awsSignin(this.email, this.password);
        if (user) {
          
          const user = await authService.mapUser(this.email,
                                                 "Cognito",
                                                 "",
                                                 this.optin,
                                                 "",
                                                 "",
                                                 "");

          window.analytics.track('user-sign-in')

          authService.redirectToApp()
        }

      } catch (error) {
        this.loginErr = error.message

        window.analytics.track('user-sign-in-error', error)
      } 
      finally { this.wait = false }
    }

  }

}
</script>



<i18n>
{
  "en": {
    "meta-title": "Winerz  |  Sign in",
    "Visit": "Visit",
    "Welcome back!": "Welcome back!",
    "Sign in with Google": "Sign in with Google",
    "Sign in with Facebook": "Sign in with Facebook",
    "To adapt to the web3, social login is not possible anymore.": "To adapt to the web3, social login is not possible anymore.",
    "If you previously had and account on Winerz with a social account, we invite you to register again with the same e-mail, your new account will be automatically linked to the previous one." : "If you previously had and account on Winerz with a social account, we invite you to register again with the same e-mail, your new account will be automatically linked to the previous one.",
    "Click here to create or link your Account" : "Click here to create or link your Account",
    "use-same-email": "(reminder: use the <span>same e-mail address</span> of your social account)",
    "E-mail address": "E-mail address",
    "Password": "Password",
    "Please wait...": "Please wait...",
    "Log In": "Sign In",
    "Forgot your password?": "Forgot your password?",
    "Create an account": "Create an account"
  },
  "fr": {
    "meta-title": "Winerz  |  Connexion",
    "Visit": "Visitez",
    "Welcome back!": "Se connecter",
    "Sign in with Google": "Se connecter avec Google",
    "Sign in with Facebook": "Se connecter avec Facebook",
    "To adapt to the web3, social login is not possible anymore.": "Afin de s'adapter au web3, il n'est plus possible de t'identifier avec un réseau social.",
    "If you previously had and account on Winerz with a social account, we invite you to register again with the same e-mail, your new account will be automatically linked to the previous one." : "Si tu étais précédemment inscrit sur Winerz avec un réseau social, nous t'invitons à te réinscrire avec le même e-mail, ton nouveau compte sera automatiquement lié au précédent.",
    "Click here to create or link your Account" : "Clique ici pour créer ou lier ton compte",
    "use-same-email": "(rappel: utilise le <span>même e-mail</span> que ton réseau social)",
    "E-mail address": "Adresse e-mail",
    "Password": "Mot de passe",
    "Please wait...": "Merci de patienter...",
    "Log In": "Se connecter",
    "Forgot your password?": "Mot de passe oublié ?",
    "Create an account": "Créer un compte"
  }
}
</i18n>
